// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../img/deny.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, "\n.popovermenu[data-v-057c3e6c] {\n\ttop: 38px;\n\tright: -5px;\n}\nbutton[data-v-057c3e6c] {\n\theight: 24px;\n\tborder-color: transparent;\n}\nbutton[data-v-057c3e6c]:hover {\n\theight: 24px;\n\tborder-color: #0082c9;\n\tborder-color: var(--color-primary, #0082c9);\n}\n.icon-deny[data-v-057c3e6c] {\n\tbackground-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");\n}\n.inherited[data-v-057c3e6c] {\n\topacity: 0.5;\n}\n", ""]);
// Exports
module.exports = exports;
